/** Chuỗi của "Gói SAPA & tin Zalo" + dải báo hạn dùng (phản ánh 25/09 đợt 4). Tiếng Việt có dấu, câu ngắn. */
export const GS = {
  tab: 'Gói SAPA & tin Zalo',
  goiTieuDe: 'Gói SAPA của tiệm',
  tinhTrang: (tt: string, muc: string) =>
    tt === 'tam-ngung'
      ? 'Tiệm đang tạm ngưng'
      : tt === 'het-dung-thu'
        ? 'Đã hết thời gian dùng thử'
        : tt === 'het-han'
          ? 'Gói đã hết hạn'
          : muc === 'an-han'
            ? 'Gói đã hết kỳ — đang trong 7 ngày gia hạn'
            : 'Đang dùng bình thường',
  dungThuDen: (ngay: string) => `Dùng thử đến hết ${ngay}`,
  daTraDen: (ngay: string) => `Đã trả đến hết ${ngay}`,
  khongHan: 'Không giới hạn thời gian',
  conNgay: (n: number) => `còn ${n} ngày`,
  // SAPA đang miễn phí (ADR-113): thay dòng hạn dùng thử / đã trả, bảng giá và mã chuyển khoản.
  mienPhiTinhTrang: 'SAPA đang miễn phí cho tiệm của bạn.',
  mienPhiTinZalo: 'Tin nhắn Zalo tự động là phần riêng. Muốn dùng, bạn báo SAPA.',
  tamNgungHuongDan: 'Tiệm đang tạm ngưng — liên hệ SAPA để mở lại.',
  zbsTiemDongMienPhi:
    'Tin Zalo tự động đang dừng vì tiệm đang tạm ngưng. Quầy nhắc khách bằng tay.',
  goiGiaHan: 'Muốn gia hạn hay đổi gói: bạn gọi hoặc nhắn Zalo cho SAPA.',
  lichSuTra: 'Lịch sử trả tiền',
  soThang: (n: number) => `${n} tháng`,
  daDao: 'đã huỷ khoản này',

  zbsTieuDe: 'Tin nhắn Zalo',
  // ADR-073: chỉ tin nhắc được gửi thật (xác nhận / biên nhận khách đã thấy tận mắt).
  zbsDangBat: 'Tiệm đang gửi tin Zalo tự động nhắc khách trước giờ hẹn.',
  zbsChuaBat: 'Tiệm chưa bật gửi tin Zalo tự động — quầy nhắc khách bằng tay, không tốn tiền.',
  zbsTiemDong:
    'Tin Zalo tự động đang dừng vì gói SAPA đã hết hạn / tiệm tạm ngưng. Quầy nhắc khách bằng tay.',
  chonThang: 'Chọn tháng',
  thang: (t: string) => `Tháng ${t.slice(5, 7)}/${t.slice(0, 4)}`,
  daTieu: 'Đã dùng',
  tran: 'Hạn mức tháng',
  conLai: 'Còn lại',
  tranMacDinh: 'hạn mức mặc định, muốn tăng thì báo SAPA',
  gan80: 'Đã dùng hơn 80% hạn mức tháng. Hết hạn mức thì tin tự động dừng, quầy nhắc tay.',
  het: 'Đã hết hạn mức tháng này — tin tự động đang dừng. Quầy nhắc khách bằng tay, hoặc báo SAPA để tăng.',
  daTieuThangCu: (thang: string) => `${thang} đã dùng`,
  theoLoai: 'Dùng vào những tin nào',
  chuaCoTin: 'Tháng này chưa gửi tin nào.',
  cotLoai: 'Loại tin',
  cotSoTin: 'Số tin',
  cotTien: 'Tiền',
  boQuaNganSach: (n: number) => `${n} tin không gửi vì hết hạn mức`,
  boQuaDongY: (n: number) => `${n} tin không gửi vì khách đã tắt nhận tin`,
  thatBai: (n: number) => `${n} tin gửi không được (không tính tiền)`,
  tinGan: (n: number) => `Xem ${n} tin gần nhất`,
  trangThai: (s: string) =>
    s === 'sent'
      ? 'đã gửi'
      : s === 'queued'
        ? 'đang gửi'
        : s === 'skipped_budget'
          ? 'hết hạn mức'
          : s === 'skipped_consent'
            ? 'khách tắt nhận tin'
            : s === 'failed'
              ? 'không gửi được'
              : s,

  dai: (muc: string, ngay: number | null) =>
    muc === 'tam-ngung'
      ? 'Tiệm đang tạm ngưng: tin Zalo tự động dừng. Quầy vẫn làm việc bình thường.'
      : muc === 'da-het'
        ? 'Gói SAPA đã hết hạn: tin Zalo tự động dừng. Quầy vẫn làm việc bình thường.'
        : muc === 'an-han'
          ? `Gói SAPA đã hết kỳ. Còn ${ngay ?? 0} ngày để gia hạn, sau đó tin Zalo tự động sẽ dừng.`
          : `Gói SAPA còn ${ngay ?? 0} ngày.`,
  daiXem: 'Xem gói',

  // 5.4 (ADR-094): dải khi SAPA cập nhật Điều khoản dịch vụ cho cửa hàng — chủ tiệm có sẵn.
  dkCapNhat: 'SAPA cập nhật điều khoản dịch vụ',
  dkDoc: 'Đọc điều khoản',
  dkDongY: 'Đồng ý',
  dkDangGhi: 'Đang lưu…',
  dkDaGhi: 'Đã ghi nhận bạn đồng ý điều khoản.',

  // 5.6 (ADR-094): bảng giá + chuyển khoản. Không cổng thanh toán, không tự gia hạn (NOT-DOING #24).
  giaTieuDe: 'Bảng giá SAPA',
  giaGoiY: 'Tính cho mỗi cửa hàng, không chia mức theo số nhân viên.',
  giaThang: (tien: string) => `${tien} / tháng`,
  giaNiemYet: 'Giá niêm yết cho mỗi cửa hàng.',
  giaThuKin: (thangGiu: number, thangMien: number) =>
    `Dành cho tiệm trong nhóm thử kín của SAPA: giữ giá này ${thangGiu} tháng, miễn phí ${thangMien} tháng đầu.`,
  giaNamTieuDe: (dong: number, tang: number) => `Đóng ${dong} tháng, tặng ${tang} tháng`,
  giaNam: (dong: number, dung: number, niemYet: string, thuKin: string) =>
    `Trả ${dong} tháng được dùng ${dung} tháng: ${niemYet} (giá niêm yết) hoặc ${thuKin} (nhóm thử kín).`,
  giaZaloTieuDe: 'Tin nhắn Zalo tự động',
  giaZalo: (toiThieu: string) =>
    `Nạp tối thiểu ${toiThieu}. SAPA bán đúng giá vốn của Zalo, không cộng thêm.`,
  ckTieuDe: 'Chuyển khoản phí gói SAPA',
  ckHuongDan:
    'Quét mã bằng ứng dụng ngân hàng, nhập số tiền theo bảng giá. Nhớ giữ nguyên nội dung để SAPA nhận ra tiệm của bạn.',
  ckNganHang: 'Ngân hàng',
  ckSoTk: 'Số tài khoản',
  ckChuTk: 'Chủ tài khoản',
  ckNoiDung: 'Nội dung chuyển khoản',
  ckChep: 'Chép',
  ckDaChep: 'Đã chép',
  ckKhongChep: 'Máy không chép được. Bạn tự gõ giúp nhé.',
  ckSauKhiChuyen:
    'Chuyển xong, bạn nhắn SAPA biết. Khi SAPA ghi nhận, hạn gói mới hiện ở trên. SAPA không tự trừ tiền hay tự gia hạn.',
  ckKhongCoMa: 'Chưa có mã tiệm để ghi nội dung. Bạn gọi hoặc nhắn SAPA để được hướng dẫn.',
  ckAnhMaQr: 'Mã QR chuyển khoản tới tài khoản của SAPA',
}
